<template>
  <div class="title-wrapper mb-3">
    <div class="countdown mb-1" v-if="countdown && countdownPosition === 'top'">
      <small v-translate="{countdown: countdown}">Autorefresh in %{countdown}s</small>
      <b-progress height="2px" :value="countdown" :max="countdownMax"></b-progress>
    </div>
    <h1 class="m-0">
      <i class="icon mr-3" :class="icon" v-if="icon"></i>
      <slot class="d-inline-block title"></slot>
      <span class="d-inline-block ml-3">
        <slot name="extras"></slot>
      </span>
    </h1>
    <div class="countdown mt-1" v-if="countdown && countdownPosition === 'bottom'">
      <b-progress height="2px" :value="countdown" :max="countdownMax"></b-progress>
      <small v-translate="{countdown: countdown}">Autorefresh in %{countdown}s</small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageTitle',
  props: {
    icon: {
      type: String,
      default: ''
    },
    countdown: {
      type: [
        String,
        Number
      ],
      default: null
    },
    countdownMax: {
      type: [
        Number
      ],
      default: 60
    },
    countdownPosition: {
      type: String,
      default: 'bottom'
    }
  }
}
</script>

<style lang="scss">
.title-wrapper {
  h1 {
    position: relative;
    display: flex;
    align-items: center;
    font-weight: 300;
    line-height: 1em;
    .icon {
      height: 1.5em;
      line-height: 1.5em;
      width: 1.5em;
      flex-shrink: 0;
      text-align: center;
      border-radius: .2em;
      background-color: #ddd;
    }
    .title {
      flex-grow: 1;
    }
  }
}
</style>
